import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import LojasNaoPositivadas from "./components/LojasNaoPositivadas";
import PositivacaoDigital from "./components/PositivacaoDigital";
import { Footer } from "../../components/Footer/Footer";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

const OBJECT_IDS = {
  RANKING: "tjQzgaU",
};


function BaseCovarageDesktop({ app }) {
  const { selections } = useSelections();
  const [nameUser, setNameUser] = useState("");
  const { isLoading } = useOverviewData(app);

  const getNameUser = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          setNameUser(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );


  useEffect(() => {
    if (app) {
      getNameUser(OBJECT_IDS.USER_NAME);
    }
  }, [app, getNameUser, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection="column"
            justifyContent="flex-start"
            rowGap={2}
          >
            {isLoading ? (
              <Grid container spacing={2}>
                {/* First row - 2 columns */}
                <Grid item xs={12}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>

                {/* Second row - 4 equal columns */}
                <Grid item xs={12} >
                  <OverviewCardSkeleton variant="retangle" />
                </Grid>
              </Grid>
            ) : (
              <Grid item spacing={2} sx={{ marginBottom: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} className="container-tables-tops">
                  <PositivacaoDigital app={app} />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} className="container-tables-tops">
                    <LojasNaoPositivadas app={app} />
                  </Grid>
                </Grid>
                <Grid item spacing={2}>
                  <Footer app={app} />
                </Grid>
              </Grid>
            )}
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

BaseCovarageDesktop.propTypes = {
  app: PropTypes.object,
};

export default BaseCovarageDesktop;
